'use strict'

const oneForAllProjects = {
    "nexity-test__12456": { 
        "id": "7rlBuTioFAR4IYSxRUnd0b", // Staging
        "key": "3Ar3lK5itYVOE6HOb036Mj",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0038__35051": {
        "id": "2Oxns8RSXdvI2egKj8kkAh", // Production - Villa Daubigny 
        "key": "1fmyKduOpNtRZLQTWHCFAZ",
        "styles": {
            "background-color": "#f5f4f2"
        }
    }, 
    "nexity-0038__35052": {
        "id": "6ywhfScuRi6awO0v8X9MGO", // Production - Clos du bois
        "key": "1fmyKduOpNtRZLQTWHCFAZ",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0038__35005": {
        "id": "49ida9lp7oBMhs2WWWLGNP", // Production - Lac en scène
        "key": "1fmyKduOpNtRZLQTWHCFAZ",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0038__36007": {
        "id": "4IuTrRYI7MmN4SLAb1N8uG", // Production - Tilia
        "key": "1fmyKduOpNtRZLQTWHCFAZ",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0050__87211": {
        "id": "6V4ZWg2JwVeH9vKaypVHS8", // Production - Marseille
        "key": "76fO9uLJqOWHh89SynC9dk",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0038__35085": {
        "id": "3kPxyUoe66A7mRfP2LpyDU", // Production - Bezons
        "key": "1fmyKduOpNtRZLQTWHCFAZ",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0050__21038": {
        "id": "7FsAfmlq2yJrGfLeMrJhZt", // Production - Draguignan
        "key": "H8TuKiby0twuxiJyJK9nx",
        "styles": {
            "background-color": "#f5f4f2"
        }
    },
    "nexity-0079_58P_07253": {
        "id": "y1xJu1SwcNjhJ2vMhYvFo", // Production - Elne
        "key": "H8TuKiby0twuxiJyJK9nx",
        "styles": {
            "background-color": "#f5f4f2"
        }
    }
}

export { oneForAllProjects };


// WEBPACK FOOTER //
// ./src/private/oneForAllProjects.js